import React from 'react';
// import { makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';


// const useStyles1 = makeStyles(() => ({
//     root: {
//       maxWidth: 304,
//       margin: 'auto',
//     },
//     content: {
//       padding: 24,
//     },
//     avatar: {
//         position:'absolute',
//         marginTop:'-3%',
//         marginLeft:'12%',
//       width: 50,
//       height: 50,
//       border: '2px solid #fff',
//       margin: '-48px 32px 0 auto',
//       '& > img': {
//         margin: 0,
//       },
//     },
//   }));

export default function TBOHotelDetail(props) {
//   const cardStyles = useStyles1();
//   const shadowStyles = useSoftRiseShadowStyles();
//   const textCardContentStyles = useN01TextInfoContentStyles();
//   const { height, width } = useWindowDimensions();
//   console.log(width,height);
const calc = (num) => {
  num = num.toString(); //If it's not already a String
  num = num.slice(0, (num.indexOf("."))+3); //With 3 exposing the hundredths place
  return Number(num); //If you need it back as a Number

}
  return (
        <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Customer Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>First Name</TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.data.booking.Rooms.map((item,index)=>{

                            return item.CustomerDetails[0].CustomerNames.map((items, keys)=>{
                                return <TableRow  key={keys}>
                                        <TableCell component="th" scope="row">
                                            {items.Title}
                                        </TableCell>
                                        <TableCell>{items.FirstName}</TableCell>
                                        <TableCell>{items.LastName}</TableCell>
                                        <TableCell>{items.Type}</TableCell>
                                    </TableRow>
                            })

                        })
                    }
                    
                </TableBody>
              </Table>
            </Box>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Room Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Total Fare</TableCell>
                    <TableCell>Total Tax</TableCell>
                    <TableCell>Inclusion</TableCell>
                    <TableCell>Meals Type</TableCell>
                  </TableRow>
                </TableHead>
                 <TableBody>
                    {
                        props.data.booking.Rooms.map((items,keys)=>{   
                        return <TableRow  key={keys}>
                                <TableCell component="th" scope="row">
                                    {items.Name[0]}
                                </TableCell>
                                <TableCell>{calc(items.TotalFare+props.data.commissionAmount)} {items.Currency}</TableCell>
                                <TableCell>{calc(items.TotalTax)}  {items.Currency}</TableCell>
                                <TableCell>{items.Inclusion}</TableCell>
                                <TableCell>{items.MealType}</TableCell>
                            </TableRow>
                        })
                    }
                    {/*<TableRow>
                        <TableCell rowSpan={4} />
                        <TableCell rowSpan={4} />
                        <TableCell rowSpan={4} />
                        <TableCell rowSpan={4} />
                        <TableCell rowSpan={4} />
                        <TableCell colSpan={2}>EquiFare</TableCell>
                        <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.EquiFare.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>Service Tax</TableCell>
                        <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.ServiceTax.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>Tax</TableCell>
                        <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.Tax.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>Total Fare</TableCell>
                        <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.TotalFare.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                    </TableRow> */}
                    
                    
                </TableBody>
              </Table>
            </Box>
        </TableCell>
      </TableRow>
  );
}


// WEBPACK FOOTER //
// ./src/Pages/TBOHotelDetail.js